import { gql } from '@apollo/client';

const getFAQs = gql`
  query GetFAQs {
    faqCategoriesConnection(orderBy: priority_ASC) {
      edges {
        node {
          faqCategory
          displayName
        }
      }
    }
    fAQs(where: { faq_product: CONNECT }) {
      question
      id
      answer
      faq_category
      priority
    }
  }
`;

export default getFAQs;
